document.addEventListener("DOMContentLoaded", () => {

  // ── GSAP HERO ANIMATIONS ──
  const tl = gsap.timeline({ delay: 0.2 });

  tl.from(".gs-fade", {
    y: 30,
    opacity: 0,
    duration: 1,
    stagger: 0.15,
    ease: "power3.out"
  }, 0);

  tl.from(".word", {
    y: "120%",
    duration: 1.2,
    stagger: 0.1,
    ease: "power4.out"
  }, 0.1);

  // ── CUSTOM CURSOR ──
  const cursor = document.getElementById('cursor');
  if (cursor) {
    document.addEventListener('mousemove', e => {
      cursor.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
    });

    document.querySelectorAll('a, button, .prod-card, .testi-card, .feature-item, .nav-logo').forEach(el => {
      el.addEventListener('mouseenter', () => cursor.classList.add('big'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('big'));
    });
  }

  // ── MAGNETIC BUTTON EFFECT ──
  const magneticEls = document.querySelectorAll('.magnetic, .nav-cta, .nav-logo');
  magneticEls.forEach((el) => {
    el.addEventListener("mousemove", function (e) {
      const position = el.getBoundingClientRect();
      const x = e.pageX - position.left - position.width / 2;
      const y = e.pageY - position.top - position.height / 2;

      el.style.transform = `translate(${x * 0.3}px, ${y * 0.5}px)`;
    });

    el.addEventListener("mouseout", function (e) {
      el.style.transform = "translate(0px, 0px)";
      el.style.transition = "transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)";
    });
    
    el.addEventListener("mouseenter", function (e) {
      el.style.transition = "none";
    });
  });

  // ── NAVBAR SCROLL EFFECT (ALWAYS STICKY) ──
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      const currentY = window.scrollY;
      nav.classList.toggle('scrolled', currentY > 40);
    }, { passive: true });
  }

  // ── MOBILE MENU TOGGLE ──
  const burger = document.getElementById('burger');
  const navUltra = document.getElementById('nav');
  const navMobileLinks = document.querySelectorAll('.nav-mobile-link');

  if (burger && navUltra) {
    burger.addEventListener('click', () => {
      navUltra.classList.toggle('menu-open');
      document.body.style.overflow = navUltra.classList.contains('menu-open') ? 'hidden' : '';
    });

    navMobileLinks.forEach(link => {
      link.addEventListener('click', () => {
        navUltra.classList.remove('menu-open');
        document.body.style.overflow = '';
      });
    });
  }

  // ── NJ SCROLL REVEAL SYSTEM ──
  const njObserverOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const njObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        // Unobserve if we don't want it to repeat
        if (!entry.target.classList.contains('nj-repeat')) {
          njObserver.unobserve(entry.target);
        }
      } else {
        // If repeating is enabled, remove visible class when out of view
        if (entry.target.classList.contains('nj-repeat')) {
          entry.target.classList.remove('visible');
        }
      }
    });
  }, njObserverOptions);

  // Auto attach reveal classes to sections and cards for seamless scroll animations
  document.querySelectorAll('section, .product-card, .col-product-card, .pillar-card, .contact-info-card, .reviews-card, .bestseller-card, .nj-404-wrap, .atesti-card').forEach((el) => {
    if (!el.classList.contains('nj-reveal') && !el.classList.contains('reveal') && !el.classList.contains('hero')) {
      el.classList.add('nj-reveal', 'nj-fade-up');
    }
  });

  document.querySelectorAll('.nj-reveal, .nj-stagger, .reveal, .ritual-step').forEach(el => {
    njObserver.observe(el);
  });

  // ── RITUAL PREMIUM SCROLL (FLAT / WINDOW SCROLL) ──
  (function () {
    const ritualSec = document.getElementById('ritual');
    if (!ritualSec) return;

    const slides   = Array.from(ritualSec.querySelectorAll('.ritual-slide-new'));
    const TOTAL    = slides.length;
    const progress = document.getElementById('ritual-progress-bar');
    const pips     = document.getElementById('ritual-pips');
    const dots     = document.getElementById('ritual-dots');
    const hint     = document.getElementById('ritual-hint');
    const sqSvg    = document.getElementById('ritual-squiggle-svg');

    /* ── SQUIGGLE PATHS ── */
    const SQ_DEFS = [
      "M760 30 C720 90 800 150 755 220 C710 285 780 330 745 400 C715 455 768 490 745 555",
      "M745 555 C720 615 778 660 748 725 C718 785 770 820 748 880",
      "M748 880 C725 940 775 978 748 1040 C720 1098 770 1135 748 1200 C726 1255 772 1285 750 1350",
      "M750 1350 C728 1408 774 1445 750 1510 C726 1565 770 1598 750 1660 C732 1710 765 1740 752 1790"
    ];
    const sqEls = SQ_DEFS.map((d, i) => {
      const el = document.getElementById('rsq' + i);
      if (!el) return null;
      el.setAttribute('d', d);
      const len = el.getTotalLength();
      el.style.strokeDasharray  = len;
      el.style.strokeDashoffset = len;
      el._len = len;
      return el;
    }).filter(Boolean);

    function drawSquiggles(stepFloat) {
      sqEls.forEach((el, i) => {
        const t = Math.max(0, Math.min(1, stepFloat - i));
        el.style.strokeDashoffset = el._len * (1 - t);
        el.style.transition = (t > 0 && t < 1)
          ? 'stroke-dashoffset .35s cubic-bezier(.4,0,.2,1)' : 'none';
      });
    }

    /* ── INTERSECTION OBSERVER — slide in/out ── */
    const slideObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting && e.intersectionRatio >= 0.5)
          e.target.classList.add('is-visible');
        else if (e.intersectionRatio === 0)
          e.target.classList.remove('is-visible');
      });
    }, { threshold: [0, 0.5, 1] });
    slides.forEach(s => slideObs.observe(s));

    /* ── SHOW/HIDE fixed UI while ritual section is in viewport ── */
    const uiEls = [progress, pips, dots, hint, sqSvg];
    const sectionObs = new IntersectionObserver(entries => {
      const on = entries[0].isIntersecting;
      uiEls.forEach(el => el && el.classList.toggle('ritual-ui-on', on));
    }, { threshold: 0.05 });
    sectionObs.observe(ritualSec);

    /* ── SCROLL HANDLER ── */
    function onScroll() {
      const rect      = ritualSec.getBoundingClientRect();
      const winH      = window.innerHeight;
      const secHeight = ritualSec.offsetHeight;

      // how far we've scrolled INTO the section (0 … secHeight)
      const scrolled  = Math.max(0, -rect.top);
      const maxScroll = secHeight - winH;
      const prog      = maxScroll > 0 ? Math.min(1, scrolled / maxScroll) : 0;

      if (progress) progress.style.width = (prog * 100) + '%';

      const stepFloat  = scrolled / winH;
      drawSquiggles(stepFloat);

      const activeStep = Math.min(Math.round(stepFloat), TOTAL - 1);
      ritualSec.querySelectorAll('.ritual-pip, .ritual-dot').forEach(el => {
        el.classList.toggle('on', parseInt(el.dataset.i) === activeStep);
      });

      if (hint) hint.classList.toggle('gone', prog > 0.95);

      // Hide UI if we've scrolled past the section
      uiEls.forEach(el => {
        if (el) {
          if (prog >= 1 || prog <= 0) {
            el.classList.remove('ritual-ui-on');
          } else {
             // Let the IntersectionObserver handle the general visibility, 
             // but force it OFF at the extreme boundaries.
          }
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ── CLICK NAV ── */
    function scrollToStep(i) {
      const target = ritualSec.offsetTop + i * window.innerHeight;
      window.scrollTo({ top: target, behavior: 'smooth' });
    }
    ritualSec.querySelectorAll('.ritual-pip, .ritual-dot').forEach(el =>
      el.addEventListener('click', () => scrollToStep(parseInt(el.dataset.i)))
    );
  })();




  // ── FEATURES SECTION ANIMATIONS ──
  const featObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('feat-visible');
        featObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });

  const featSec = document.getElementById('values');
  if (featSec) featObserver.observe(featSec);

  // ── ANIMATED TESTIMONIALS ──
  (function () {
    const TESTIMONIALS = [
      {
        name: 'Priya',
        role: 'Home Spa Enthusiast',
        location: 'Mumbai',
        content: 'The Chocolate Mani-Pedi Kit is absolutely divine. My hands feel like I just walked out of a luxury salon — every single time!',
        rating: 5,
        avatar: 'https://i.pravatar.cc/96?img=47'
      },
      {
        name: 'Ananya',
        role: 'Skincare Lover',
        location: 'Bangalore',
        content: 'The Hydra sheet mask with watermelon extract is a game changer. Skin felt plump and bright within 20 minutes. Absolutely love it.',
        rating: 5,
        avatar: 'https://i.pravatar.cc/96?img=44'
      },
      {
        name: 'Ritu',
        role: 'Wellness Blogger',
        location: 'Delhi',
        content: 'Finally a paraben-free kit that actually works! The classic pedicure spa kit is now my weekly Sunday ritual. Cannot recommend it enough.',
        rating: 5,
        avatar: 'https://i.pravatar.cc/96?img=49'
      },
      {
        name: 'Sneha',
        role: 'Working Professional',
        location: 'Pune',
        content: 'I gifted the foot care kit to my mom and she absolutely loves it. The Dead Sea salt soak is incredibly relaxing after a long day.',
        rating: 5,
        avatar: 'https://i.pravatar.cc/96?img=53'
      }
    ];

    const cardsEl = document.getElementById('atesti-cards');
    const dotsEl  = document.getElementById('atesti-dots');
    if (!cardsEl || !dotsEl) return;

    let activeIdx = 0;
    let autoTimer = null;

    /* ── STAR SVG ── */
    function starSvg() {
      return `<svg class="atesti-star" viewBox="0 0 24 24"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>`;
    }

    /* ── QUOTE SVG ── */
    function quoteSvg() {
      return `<svg class="atesti-quote-icon" viewBox="0 0 24 24" fill="currentColor"><path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/></svg>`;
    }

    /* ── BUILD CARDS ── */
    TESTIMONIALS.forEach((t, i) => {
      const card = document.createElement('div');
      card.className = 'atesti-card' + (i === 0 ? ' active' : '');
      card.innerHTML = `
        <div class="atesti-stars">${starSvg().repeat(t.rating)}</div>
        <div class="atesti-quote-wrap">
          ${quoteSvg()}
          <p class="atesti-quote-text">"${t.content}"</p>
        </div>
        <div class="atesti-sep"></div>
        <div class="atesti-author-row">
          <img class="atesti-avatar" src="${t.avatar}" alt="${t.name}" onerror="this.style.display='none';this.nextElementSibling.style.display='flex'">
          <div class="atesti-avatar-fallback" style="display:none">${t.name.charAt(0)}</div>
          <div>
            <div class="atesti-name">${t.name}</div>
            <div class="atesti-role">${t.role} · ${t.location}</div>
          </div>
        </div>`;
      cardsEl.appendChild(card);
    });

    /* ── BUILD DOTS ── */
    TESTIMONIALS.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'atesti-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', `Testimonial ${i + 1}`);
      dot.addEventListener('click', () => goTo(i));
      dotsEl.appendChild(dot);
    });

    const cards = Array.from(cardsEl.querySelectorAll('.atesti-card'));
    const dots  = Array.from(dotsEl.querySelectorAll('.atesti-dot'));

    /* ── NAVIGATE ── */
    function goTo(idx) {
      cards[activeIdx].classList.remove('active');
      dots[activeIdx].classList.remove('active');
      activeIdx = idx;
      cards[activeIdx].classList.add('active');
      dots[activeIdx].classList.add('active');
    }

    /* ── AUTO ROTATE ── */
    function startAuto() {
      autoTimer = setInterval(() => {
        goTo((activeIdx + 1) % TESTIMONIALS.length);
      }, 6000);
    }
    function resetAuto() {
      clearInterval(autoTimer);
      startAuto();
    }

    dots.forEach((d, i) => d.addEventListener('click', () => resetAuto()));
    startAuto();
  })();



  // ── LEAF PARTICLES ──
  function createLeaves() {
    const hero = document.querySelector('.hero');
    if (!hero) return;
    const leafColors = [
      'rgba(106,154,58,0.65)',
      'rgba(139,184,78,0.55)',
      'rgba(201,168,76,0.50)',
      'rgba(232,134,30,0.45)',
      'rgba(212,100,26,0.40)',
    ];
    const shapes = [
      '50% 10% 50% 10%',
      '10% 50% 10% 50%',
      '60% 10% 60% 10%',
      '40% 60% 10% 80%',
      '50% 50% 10% 10%',
    ];
    
    // Create container for leaves to ensure they sit above video but below content
    const leafContainer = document.createElement('div');
    leafContainer.style.position = 'absolute';
    leafContainer.style.inset = '0';
    leafContainer.style.pointerEvents = 'none';
    leafContainer.style.zIndex = '1';
    leafContainer.style.overflow = 'hidden';
    hero.appendChild(leafContainer);

    for (let i = 0; i < 20; i++) {
      const leaf = document.createElement('div');
      leaf.style.position = 'absolute';
      const size = 12 + Math.random() * 20;
      const dur  = 15 + Math.random() * 20;
      const del  = Math.random() * 20;
      const col  = leafColors[Math.floor(Math.random() * leafColors.length)];
      const shp  = shapes[Math.floor(Math.random() * shapes.length)];
      leaf.style.cssText = `
        left:${5 + Math.random() * 90}%;
        top:-${20 + Math.random() * 80}px;
        width:${size}px; height:${size * (0.6 + Math.random() * 0.6)}px;
        background:${col};
        border-radius:${shp};
        animation: leafFall ${dur}s linear infinite;
        animation-delay:-${del}s;
        box-shadow: 0 4px 10px ${col.replace(')', ', 0.4)').replace('rgba', 'rgba')};
        backdrop-filter: blur(2px);
      `;
      leafContainer.appendChild(leaf);
    }

    // Add keyframes dynamically
    const styleSheet = document.createElement("style");
    styleSheet.innerText = `
      @keyframes leafFall {
        0%   { opacity: 0;   transform: translateY(0) translateX(0) rotate(0deg); }
        10%  { opacity: 0.8; }
        90%  { opacity: 0.5; }
        100% { opacity: 0;   transform: translateY(110vh) translateX(100px) rotate(500deg); }
      }
    `;
    document.head.appendChild(styleSheet);
  }
  createLeaves();

  // ── BEFORE & AFTER SLIDER ──
  (function() {
    const slider       = document.getElementById('slider');
    const beforeImg    = document.getElementById('beforeImg');
    const afterImg     = document.getElementById('afterImg');
    const sliderLine   = document.getElementById('sliderLine');
    const sliderHandle = document.getElementById('sliderHandle');

    if (!slider || !beforeImg || !afterImg || !sliderLine || !sliderHandle) return;

    let dragging  = false;
    let pct       = 50;
    let animating = true;
    let rafId;

    function applyPos(p) {
      const clipValue = `inset(0 ${100 - p}% 0 0)`;
      beforeImg.style.clipPath = clipValue;
      beforeImg.style.webkitClipPath = clipValue;
      sliderLine.style.left      = p + '%';
      sliderHandle.style.left    = p + '%';
    }

    function setPosition(clientX) {
      const rect = slider.getBoundingClientRect();
      pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      applyPos(pct);
    }

    // Mouse events
    slider.addEventListener('mousedown', e => {
      e.preventDefault(); // Prevent text selection and image dragging
      dragging = true;
      animating = false;
      cancelAnimationFrame(rafId);
      setPosition(e.clientX);
    });

    window.addEventListener('mousemove', e => {
      if (dragging) {
        setPosition(e.clientX);
      }
    });

    window.addEventListener('mouseup', () => {
      dragging = false;
    });

    // Touch events (with passive: false to allow e.preventDefault() to block page scroll while sliding)
    slider.addEventListener('touchstart', e => {
      e.preventDefault(); // Prevent text selection and default scrolling gestures
      dragging = true;
      animating = false;
      cancelAnimationFrame(rafId);
      setPosition(e.touches[0].clientX);
    }, { passive: false });

    window.addEventListener('touchmove', e => {
      if (dragging) {
        e.preventDefault(); // Prevent scrolling while dragging the slider
        setPosition(e.touches[0].clientX);
      }
    }, { passive: false });

    window.addEventListener('touchend', () => {
      dragging = false;
    });

    // Auto-sweep animation
    let dir = 1;
    function autoReveal() {
      if (!animating) return;
      pct += dir * 0.20;
      if (pct >= 74) dir = -1;
      if (pct <= 26) dir =  1;
      applyPos(pct);
      rafId = requestAnimationFrame(autoReveal);
    }
    rafId = requestAnimationFrame(autoReveal);

    // Thumbnail switching — supports separate data-after / data-before per thumb
    document.querySelectorAll('.ba-thumb').forEach(t => {
      t.addEventListener('click', () => {
        document.querySelectorAll('.ba-thumb').forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        const afterUrl  = t.dataset.after;
        const beforeUrl = t.dataset.before;
        
        // Match transition duration with the fadeout delay
        beforeImg.style.transition = afterImg.style.transition = 'opacity .35s ease';
        beforeImg.style.opacity = afterImg.style.opacity = '0';
        
        setTimeout(() => {
          afterImg.style.backgroundImage  = `url('${afterUrl}')`;
          beforeImg.style.backgroundImage = `url('${beforeUrl}')`;
          beforeImg.style.opacity = afterImg.style.opacity = '1';
          
          // Clear transitions after fade-in is complete
          setTimeout(() => {
            beforeImg.style.transition = afterImg.style.transition = '';
          }, 350);
        }, 350);
        
        pct = 50;
        applyPos(pct);
        animating = true;
        cancelAnimationFrame(rafId); // Avoid duplicate loops
        rafId = requestAnimationFrame(autoReveal);
      });
    });
  })();
});
